// sm-sticky-offer-header: the show/hide-on-scroll behavior itself lives in the
// shared <sm-sticky-atc> custom element (see sm-sticky-bar snippet, ARCHITECTURE 4),
// registered by whichever sticky bar script runs first. This file only:
// 1. Hides the real site header while the bar is visible (HANDOFF 7.2).
// 2. Supports a forced-open state for visual diffs (#sm-open-menu in the URL, or
//    the theme editor).
const HASH_FORCE = 'sm-open-menu';

function headers() {
  return document.querySelectorAll('.sm-header-classic, .sm-header-offer');
}

const bar = document.getElementById('sm-sticky-offer-header');
if (bar) {
  const sync = () => {
    const visible = bar.hasAttribute('data-visible');
    headers().forEach((h) => {
      h.toggleAttribute('data-sticky-hidden', visible);
      h.setAttribute('aria-hidden', String(visible));
    });
  };
  new MutationObserver(sync).observe(bar, { attributes: true, attributeFilter: ['data-visible'] });
  sync();

  if (location.hash.includes(HASH_FORCE) || (window.Shopify && window.Shopify.designMode)) {
    bar.setAttribute('data-visible', '');
    bar.setAttribute('aria-hidden', 'false');
    sync();
  }
}
